<template>
<div  class="headerBtns">
  <v-footer padless color="app-colors-background">
    <desktop-footer
      :contactInfo="contactInfo"
      :footerItems="footerItems"
      v-if="!$vuetify.breakpoint.mobile"
    />
    <mobile-footer
      :contactInfo="contactInfo"
      :footerItems="footerItems"
      v-if="$vuetify.breakpoint.mobile"
    />
  </v-footer>
</div>
</template>
<script>
import DesktopFooter from './DesktopFooter.vue'
import MobileFooter from './MobileFooter.vue'
import { eventBus } from '../../../store/eventBus'
export default {
  name: 'Footer',
  data() {
    return {
      contactInfo: {
        supportNumber: null,
        telephoneNumber: null,
        mail: null
      }
    }
  },
  components: {
    DesktopFooter,
    MobileFooter
  },
  computed: {
    footerItems: function() {
      return this.$store.getters.footerItems
    }
  },
  methods: {
    getContactInfo: function() {
      const contactInfo = {
        supportNumber: this.$store.getters.contactsSettings.supportNumberOfPhones[0],
        telephoneNumber: this.$store.getters.contactsSettings.numberOfPhones[0],
        mail: this.$store.getters.contactsSettings.emails[0]
      }
      return contactInfo
    }
  },
  mounted() {
    eventBus.$on('isLoad', () => {
      this.$nextTick(() => {
        this.contactInfo = this.getContactInfo()
      }, 1000)
    })
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
.v-footer.v-sheet {
  padding-left: $xl-indent;
  padding-right: $xl-indent;

  .footer-info-block .infoplus {
    font-size: 1.6rem;
  }

  .v-list-group__header {
    padding: 0 !important;
  }
  .copyright {
    font-size: 1.6rem;
  }
  .footer-column {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;

    .column-title {
      font-size: 1.8rem;
    }

    span {
      color: white;
    }

    .contact-span {
      margin-top: 0.8rem;
    }

    a {
      color: white;
      text-decoration: none;
    }

    .link {
      color: white;
      text-decoration: none;
      font-size: 1.6rem;

      &:not(:first-child) {
        margin-top: 0.8rem;
      }
    }
  }
  .divider-color {
    background-color: #969696;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .v-footer.v-sheet {
    padding-left: $xs-indent;
    padding-right: $xs-indent;

    .v-list {
      width: 100%;
      .v-list-item__title {
        font-size: 2rem;
        color: white;
      }
    }
  }
}
.headerBtns {
   color: white;

  a:hover {
    color: #8ac5ff !important;
  }
}
</style>
